import React from "react";

import Style from "./Tooltip.module.css";

const Tooltip: React.FC = ({ children }) => {
  return <div className={Style.container} aria-label="tooltip">{children}</div>;
};

export default Tooltip;
